// 端口
export function getPort() {
	let query = window.location.search.substring(1)
	var vars = query.split('&')
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		if (pair[0] == 'port') {
			return pair[1]
		}
	}
	return '8099'
}

// 是否为对象
export function isPlainObject(obj) {
	return Object.prototype.toString.call(obj) === "[object Object]";
}

// 是否为空
export function isEmpty(obj) {
	if (!obj) return true;
	if (Array.isArray(obj) && obj.length == 0) return true;
	if (isPlainObject(obj) && Object.values(obj).length == 0) return true;
	return false;
}

// 时间展示
function getImTime(messageTime) {
	let today = new Date();
	const dateObj = new Date(messageTime.replace(new RegExp(/-/gm), "/"));
	if (today.getFullYear() != dateObj.getFullYear()) {
		//年份不同,显示日期
		return dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate();
	} else
		if ((today.getMonth() != dateObj.getMonth()) || (today.getDate() != dateObj.getDate())) {
			//年份相同, 月份/日期不同, 显示月-日
			return (dateObj.getMonth() + 1) + '-' + dateObj.getDate();
		} else {
			//年月日相同, 显示时间
			let h = dateObj.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = dateObj.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			return h + ':' + m;
		}
}

// 时间取值
function padZero(val) {
	return val < 10 ? `0${val}` : val;
}

// 时间个数
function timeFormat(t, format) {
	if (!format) format = "y-m-d h:i:s";
	if (t) t = new Date(t);
	else t = new Date();
	const formatArr = [
		t.getFullYear().toString(),
		padZero((t.getMonth() + 1).toString()),
		padZero(t.getDate().toString()),
		padZero(t.getHours().toString()),
		padZero(t.getMinutes().toString()),
		padZero(t.getSeconds().toString())
	];
	const reg = "ymdhis";
	for (let i = 0; i < formatArr.length; i++) {
		format = format.replace(reg.charAt(i), formatArr[i]);
	}
	return format;
}

// 好友名称
function getFriendTypeName(friendType) {
	let result = '';
	switch (friendType) {
		case 1:
			result = '员工';
			break;
		case 2:
			result = '客户';
			break;
		case 3:
			result = '服务商';
			break;
		case 4:
			result = '客户服务商';
	}
	return result;
}

// 单位名称
export function getBranchTypeName(branchType) {
	switch (branchType) {
		case 0:
			return '总部';
		case 1:
			return '网点';
		case 2:
			return '客户';
		case 3:
			return '服务商';
		case 4:
			return '客户服务商'
	}
	return '';
}

// 运单状态
export function getOperateTypeName(operateType) {
	const operateItems = {
		"10": "预报收货",
		"11": "修改收货",
		"12": "新增收货",
		"13": '补录收货',
		"14": '(已发货)收货',
		"20": '(已收货)发货',
		"21": '修改发货',
		"22": '预报发货',
		"23": '新增发货',
		"24": '补录发货',
		"30": '退回',
		"40": '退走',
		"50": "集包"
	};
	return operateItems[operateType];
}

// 生成请求信息
function createRequestInfo(item) {
	let result = '';
	switch (item.friendType) {
		case 1:
			result = '邀请"' + item.friendUserName + '"加入单位';
			if (isEmpty(item.positionName)) {
				result += '.';
			} else {
				result = result + ',岗位为' + item.positionName + '.';
			}
			break;
		case 2:
		case 3:
		case 4:
			result = '添加"' + item.friendTenantName + '"为:' + getFriendTypeName(item.friendType) + '.';
			break;
	}
	return result;
}

// 生成被请求信息
function createRequestedInfo(item) {
	let result = ''
	switch (item.friendType) {
		case 1:
			result = '邀请您加入单位';
			if (isEmpty(item.positionName)) {
				result += '.';
			} else {
				result = result + ',岗位为' + item.positionName + '.';
			}
			break;
		case 2:
		case 3:
		case 4:
			result = '添加"' + item.tenantName + '"为:' + getFriendTypeName(item.friendType) + '.';
			break;
	}
	return result;
}

// 系统消息列表
export function buildFriendShipMessage(friendShip) {
	let obj = { ...friendShip };
	if (obj.friendType == 5) {
		switch (obj.status) {
			case 10:
			case 21:
			case 31:
				obj.messageTitle = obj.userName;
				obj.content = '申请加入' + obj.friendTenantName + '成为员工.';
				break;
			case 11:
			case 20:
			case 30:
				obj.messageTitle = obj.friendUserName + obj.telNo;
				obj.content = '申请加入成为员工.';
				break;
		}
	} else {
		switch (obj.status) {
			case 10:
			case 21:
			case 31:
				obj.messageTitle = obj.tenantName;
				obj.content = createRequestInfo(obj);	//发起方
				break;
			case 11:
			case 20:
			case 30:
				obj.messageTitle = obj.friendTenantName;
				obj.content = createRequestedInfo(obj);		//操作放
				break;
		}
	}
	switch (obj.status) {
		case 10:
			obj.mark = '等待响应';
			break;
		case 11:
			break;
		case 20:
		case 21:
			obj.mark = '已同意';
			break;
		case 30:
			obj.mark = '已拒绝';
			break;
		case 31:
			obj.mark = '被拒绝';
			break;
	}
	obj.messageTime = getImTime(obj.requestTime);
	return obj;
}

// 左侧系统回话消息体
function buildFriendShipContent(item) {
	let content = '';
	if (item.friendType == 5) {
		if (item.tenantId == 'ffs') {
			content = item.userName + ':申请加入成为员工.';
		} else {
			content = item.friendUserName + item.telNo + ':申请加入成为员工.';
		}
	} else {
		switch (item.status) {
			case 10:
			case 21:
			case 31:
				content = item.tenantName + createRequestInfo(item);
				break;
			case 11:
			case 20:
			case 30:
				content = item.friendTenantName + createRequestedInfo(item);
				break;
		}
	}
	switch (item.status) {
		case 10:
			content += ' 等待响应';
			break;
		case 11:
			break;
		case 20:
		case 21:
			content += ' 已接受';
			break;
		case 30:
			content += ' 已拒绝';
			break;
		case 31:
			content += ' 被拒绝';
			break;
	}
	return content;
}

// 左侧系统回话
export function buildFriendShipSession(friendShipList) {
	let unreadCount = 0
	let lastMessageTime = "0000"
	let lastMessageIndex = 0
	friendShipList.forEach((item, index) => {
		// if (item.read == 0) { //改用
		// 	unreadCount++;
		// }
		if (item.status == 11) {
			unreadCount++;
		}
		if (item.requestTime > lastMessageTime) {
			lastMessageTime = item.requestTime;
			lastMessageIndex = index;
		}
	});
	let session = {
		'messageType': 1,
		'sessionId': 'system-session',
		'sessionTitle': '系统消息',
		'fromUserName': '系统',
		'unreadCount': unreadCount,
		'content': '{"contentType":0,"contentBody":"' + buildFriendShipContent(friendShipList[lastMessageIndex]).replace(new RegExp('"', "g"), "-") + '"}',
		'createdTime': lastMessageTime,
		'updatedTime': lastMessageTime,
		'lastMessageTime': lastMessageTime,

	};
	return session;
}

// 构建发送的消息 ——当前tenantInfo,当前userInfo，消息类型，类容体，接收方
export function buildBizMsg(tenantInfo, userInfo, currentSession, type, filename, serviceStatus, content) {
	let contentObj = {
		'contentType': type,
		'contentBody': content,
		'name': filename,
		'status': serviceStatus,
	}
	let msgObj = {
		tenantId: tenantInfo.tenantId,
		tenantName: tenantInfo.shortName,
		userCode: userInfo.userCode,
		userName: userInfo.userName,
		fromTenantId: tenantInfo.tenantId,
		fromTenantName: tenantInfo.shortName,
		fromUserCode: userInfo.userCode,
		fromUserName: userInfo.userName,
		toTenantId: currentSession.toTenantId,
		toTenantName: currentSession.toTenantName,
		toUserCode: currentSession.toUserCode,
		toUserName: currentSession.toUserName,
		sessionId: currentSession.sessionId,
		wayBillId: currentSession.wayBillId,
		wayBillNo: currentSession.wayBillNo,
		customerCode: currentSession.customerCode,
		customerName: currentSession.customerName,
		messageType: currentSession.messageType,
		content: JSON.stringify(contentObj),
		messageTime: timeFormat(),
		sendTime: new Date().getTime(),
	}
	return msgObj;
}

// 表头
export function getWeightCalcRuleName(weightCalcRule) {
	const weightCalcRuleInfo = {
		'0': '实重与体积取大',
		'1': '(实重+体积)/2',
		'2': '不计体积'
	}
	if (weightCalcRuleInfo[weightCalcRule]) {
		return weightCalcRuleInfo[weightCalcRule];
	}
	return '实重与体积取大';
}

// 表头
export function getWeightCalcRuleMultiPiecesName(weightCalcRuleMultiPieces) {
	const weightCalcRuleMultiPiecesInfo = {
		'0': '按票',
		'1': '按件0.5进位',
		'2': '按件(不进位)'
	}
	if (weightCalcRuleMultiPiecesInfo[weightCalcRuleMultiPieces]) {
		return weightCalcRuleMultiPiecesInfo[weightCalcRuleMultiPieces];
	}
	return '按件0.5进位';
}

// 货物类型
export function getGoodsTypeName(goodsType) {
	const goodsTypeInfo = {
		1: '包裹',
		2: '文件',
		3: 'PAK袋'
	}
	if (goodsTypeInfo[goodsType]) {
		return goodsTypeInfo[goodsType];
	}
	return '';
}
// 电池
export function getBatteryName(battery) {
	const batteryInfo = {
		'0': '无电',
		'1': '内电',
		'2': '外电',
		'3': '纯电'
	}
	if (batteryInfo[battery]) {
		return batteryInfo[battery];
	}
	return '';
}

